import Vue from 'vue'
export default (data) => {
    return Vue.Api.Get(data.API_URL + 'Settings?_=' + data.date);
}

